/**
 * MemoMessage — 사용자PC(/u/orders) 오더 상세팝업의 결제메모(불러톡 메모) 등록/삭제/조회.
 *
 * 레거시와의 관계
 * ───────────────
 * 기존 public/js/u-order-list.js 의 order_paymemoSave / changed_messageShow / readMgonly /
 * messagedeleteone 을 이관했다(세금/다중발행 코어 슬라이스 G — 고립도 높은 메모 서브도메인).
 *   - order_paymemoSave : 메모 등록 → 목록 갱신 + 뒤 화면 메모칸 반영
 *   - readMgonly        : 메모 목록 조회(읽기 전용)
 *   - messagedeleteone  : 메모 1건 삭제 → 목록 갱신
 *   - changed_messageShow : 팝업 뒤 리스트 화면의 메모칸을 최신값으로 반영
 *
 * 구조: 모듈 스코프 자유함수 + 브리지 클래스.
 *   - renderPayMemoHtml 은 아직 u-order-list.js(팝업 오프너 슬라이스)에 있어 bare 로 전역 해소된다.
 *     (E 슬라이스 이관 후에는 window.renderPayMemoHtml 로 해소됨 — bare 참조는 그대로 동작)
 *
 * 서버: POST /u/ajax/orders/pay-memo
 */

function order_paymemoSave(n) {
    var message = document.getElementById("order_paymemoInput").value;
    var ordernum = parseInt(n);
    if (isNaN(ordernum)) ordernum = 0;
    if (ordernum < 1) { alert("오더번호가 잘못되었습니다."); return; }
    if (message.length < 2) { alert("메모를 최소2자 이상 입력해 주세요"); return; }

    var obj2 = document.getElementById("messageListloadon");
    var adr = "/u/ajax/orders/pay-memo";
    var sendData = { "eOrderNum": ordernum, "message": message };
    $.ajax({
        type: "POST", url: adr, data: sendData, success: function (data) {
            document.getElementById("order_paymemoInput").value = "";
            obj2.innerHTML = renderPayMemoHtml(data);
            changed_messageShow(ordernum)
        }
    });
}

// 메모가 변경되었을때 리스트의 메모항목도 같이 변경시킨다.
function changed_messageShow(ordernum) {
    var obj = document.getElementById("mgLastshowagain");
    if (!obj) return;
    var tar = document.getElementById("showmessageeaTd_" + ordernum);// 팝업 뒤쪽의 리스트 화면에 있는 메모내용
    tar.innerHTML = obj.innerHTML;
}

function readMgonly(n) {
    var obj2 = document.getElementById("messageListloadon");
    var adr = "/u/ajax/orders/pay-memo";
    var sendData = { "eOrderNum": n, "message": "" };
    $.ajax({
        type: "POST", url: adr, data: sendData, success: function (data) {
            obj2.innerHTML = renderPayMemoHtml(data);
        }
    });
}

function messagedeleteone(delnum, ordernum) {
    var obj2 = document.getElementById("messageListloadon");
    var adr = "/u/ajax/orders/pay-memo";
    var sendData = { "eOrderNum": ordernum, "message": "delteoneorder998812333331x2", "deletemgnum": delnum };
    $.ajax({
        type: "POST", url: adr, data: sendData, success: function (data) {
            obj2.innerHTML = renderPayMemoHtml(data);
            changed_messageShow(ordernum);
        }
    });
}

export default class MemoMessage {
    order_paymemoSave = order_paymemoSave;
    changed_messageShow = changed_messageShow;
    readMgonly = readMgonly;
    messagedeleteone = messagedeleteone;
}
